<div
  class="kl-field"
  [class.kl-field--my-3]="marginY()"
  [class.kl-field--mb-2]="marginBottom()"
  [formGroup]="formGroup()">
  @if (label()) {
    <kl-label
      [label]="label()"
      [labelDescription]="labelDescription()"
      [isRequired]="required()"
      [htmlFor]="fieldId()" />
  }

  <div class="kl-field__control text-start">
    <p-datepicker
      [inputId]="fieldId()"
      [formControlName]="controlName()"
      [placeholder]="displayPlaceholder()"
      [readonlyInput]="readonlyInput()"
      [showIcon]="showIcon()"
      [iconDisplay]="iconDisplay()"
      [showClear]="showClear()"
      [showOnFocus]="showOnFocus()"
      [showTime]="showTime()"
      [showSeconds]="showSeconds()"
      [timeOnly]="timeOnly()"
      [hourFormat]="hourFormat()"
      [appendTo]="appendTo()"
      [fluid]="fluid()"
      [minDate]="minDate()"
      [maxDate]="maxDate()"
      [dateFormat]="effectiveDateFormat()"
      panelStyleClass="kl-datepicker-panel"
      [class.p-invalid]="showInvalid()"
      (onSelect)="onSelect()" />
  </div>

  <div class="kl-field__error text-start">
    @if (showFieldError() && controlError()) {
      <span>{{ controlError() }}</span>
    }
  </div>
</div>
